<script lang="ts">
    import SvgIcon from '$lib/components/assets/SvgIcon.svelte';
    import {ASSETS_HOST} from '../../../../consts';
    import {wordIdToFilename} from '$lib/helper-fns/wordIdToFilename';
    import {onDestroy} from 'svelte';
    import type {CurrentWord} from '$lib/stores/currentWord';

    export let currentWord: CurrentWord

    //#key block in Translation comp >> less clicking noise when navigating

    const src = ASSETS_HOST + '/audio/words/' + wordIdToFilename($currentWord!.id) + '.mp3'
    let audio = new Audio(src)

    let isPlaying = false
    audio.addEventListener('playing', () => {
        isPlaying = true
    })
    audio.addEventListener('pause', () => {
        isPlaying = false
    })
    audio.addEventListener('ended', () => {
        isPlaying = false
    })

    let startingToPlay = false
    let playPromise: ReturnType<HTMLAudioElement['play']> | null = null

    async function play() {
        if (startingToPlay) return
        startingToPlay = true
        audio.pause()
        audio.currentTime = 0
        try {
            playPromise = audio.play()
            await playPromise
        } catch (error) {
            console.error('ERROR playing audio', error)
        } finally {
            startingToPlay = false
        }
    }

    onDestroy(async () => {
        if (playPromise !== null) {
            await playPromise
        }
        if (!audio.paused) audio.pause()
    })

</script>

<div id="audio-browse-word">
    <button on:click={play}
            class:is-playing={isPlaying}
    >
        <SvgIcon name="audio"
                 viewBox="0 0 32 32"
                 height="24"
                 width="24"
        />
    </button>
</div>

<style>
    #audio-browse-word {
        position: absolute;
        bottom: 0;
        left: 50%;
        line-height: 1;
        transform: translate(-50%, calc(100% + .8em));
    }

    button {
        background: none;
        margin: 0;
        padding: .2em;
        color: var(--color-audio-browse-word);
    }

    button:hover {
        box-shadow: 0 0 0 2px var(--color-audio-browse-word) inset;
    }

    button:active,
    button.is-playing {
        background: var(--color-accent);
        color: var(--text-on-color);
        box-shadow: none;
    }

    @media (max-width: 1000px) {
        #audio-browse-word {
            transform: translate(-50%, calc(100% + 1em));
        }
    }
</style>